export const TITULO_ESCOLHA_PARCELA = 'Parcelamento'

export const LABEL_ESCOLHA_PARCELA = 'Selecione parcelamento'

export const PARCELAS_PAGAMENTO_ANUAL = [
  {
    'codigo': '1',
    'value': '1',
    'visualizacao': '1x'
  },
  {
    'codigo': '6',
    'value': '6',
    'visualizacao': '6x'
  },
  {
    'codigo': '12',
    'value': '12',
    'visualizacao': '12x'
  }
]

export const PARCELAS_PAGAMENTO_TRIMESTRAL = [
  {
    'codigo': '1',
    'value': '1',
    'visualizacao': '1x'
  },
  {
    'codigo': '3',
    'value': '3',
    'visualizacao': '3x'
  }
]
